import cx from 'classnames'
import type { ElementType } from 'react'

import {
  type PropsWithSafeExtra,
  safeRestProps,
} from '../../libs/safeRestProps'
import { typographyStyles } from './styles'
import type { TypographyStylesArgs } from './types'

type Props = PropsWithSafeExtra<
  'div',
  'children' | 'className' | 'id',
  {
    as?: ElementType
  } & TypographyStylesArgs
>

export const Typography = ({
  as: Element = 'div',
  children,
  className,
  size,
  intensity,
  weight,
  extraProps = {},
  ...restProps // Needed since we can pass other props like aria-*, data-* etc. or spread that isn't type checked
}: Props) => (
  <Element
    className={cx(typographyStyles({ size, intensity, weight }), className)}
    {...safeRestProps(extraProps, restProps)}
  >
    {children}
  </Element>
)
